module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ee-Fb-Gb.5e044c90.png";